import { render, staticRenderFns } from "./ProjectBusinessInfo.vue?vue&type=template&id=535c4f6f&scoped=true&"
import script from "./ProjectBusinessInfo.vue?vue&type=script&lang=ts&"
export * from "./ProjectBusinessInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectBusinessInfo.vue?vue&type=style&index=0&id=535c4f6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535c4f6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
